import React from 'react';
import ResetLayout from '../../components/auth/ResetLayout';
import RecorverPassword from '../../components/auth/RecoverPassword';

export default function ResetPassword() {
  return <RecorverPassword />;
}
